module.exports = __webpack_public_path__ + "static/media/ux.b46710ff.svg";